module.exports = __webpack_public_path__ + "img/train-booking.1089e5d9.svg";